/**
 * Title case a passed string
 * @param {String} text String to capitalize
 */
const capitalize = text => {
    if (typeof text !== 'string') return;
    return text.charAt(0).toUpperCase() + text.slice(1);
};

/**
 * Converts snake case to title case
 * Intended for section name -> browser title
 * vessel-name -> Vessel Name
 * @param {String} text String to convert
 */
const snakeCaseToCapitalCase = (text = '') => {
    return text
        ?.split(/[-_]/g)
        ?.map(piece => capitalize(piece))
        ?.join(' ');
};

const toSnakeCase = (text = '') => {
    return text?.toLowerCase().replaceAll(/[^A-Z0-9]/gi, '_');
};

const toKebabCase = (text = '') => {
    return text?.toLowerCase().replaceAll(/[ [\].]/g, '-');
};

const addMonths = (date, nMonths) => {
    return new Date(date.setMonth(date.getMonth() + nMonths));
};

const addDays = (date, nDays) => {
    return new Date(date.setDate(date.getDate() + nDays));
};

const cropAndEllipsis = (text, length = 200) => {
    // only run if length is something reasonable
    if (length > 4 && text && length) {
        if (text?.length <= length) {
            return text;
        } else {
            return `${text?.slice(0, length - 3)}...`;
        }
    } else {
        return text;
    }
};

const intToWord = {
    0: 'no',
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four',
    5: 'five',
    6: 'six',
    7: 'seven',
    8: 'eight',
    9: 'nine',
};

const writtenNumber = number => {
    return intToWord[number] || number;
};

const phoneFormat = string => {
    if (string.length === 10) {
        return `(${string.slice(0, 3)}) ${string.slice(3, 6)}-${string.slice(
            6,
            10
        )}`;
    } else {
        return string;
    }
};

const printValue = value => {
    if (value === true || value === 'true') {
        return 'Yes';
    } else if (value === false || value === 'false') {
        return 'No';
    } else {
        return `${value}`;
    }
};

const dateFormatter = date => {
    if (date) {
        const [newDate] = date.split('T');
        const [year, month, day] = newDate?.split('-');
        return `${month}/${day}/${year}`;
    } else {
        return null;
    }
};

const numberDaysBetween = (start, end) => {
    return parseInt((new Date(end) - new Date(start)) / (3600 * 1000 * 24)) + 1;
};

const stateAbbreviationDict = {
    Alabama: 'AL',
    Alaska: 'AK',
    Arizona: 'AZ',
    Arkansas: 'AR',
    California: 'CA',
    'Canal Zone': 'CZ',
    Colorado: 'CO',
    Connecticut: 'CT',
    Delaware: 'DE',
    'District of Columbia': 'DC',
    Florida: 'FL',
    Georgia: 'GA',
    Guam: 'GU',
    Hawaii: 'HI',
    Idaho: 'ID',
    Illinois: 'IL',
    Indiana: 'IN',
    Iowa: 'IA',
    Kansas: 'KS',
    Kentucky: 'KY',
    Louisiana: 'LA',
    Maine: 'ME',
    Maryland: 'MD',
    Massachusetts: 'MA',
    Michigan: 'MI',
    Minnesota: 'MN',
    Mississippi: 'MS',
    Missouri: 'MO',
    Montana: 'MT',
    Nebraska: 'NE',
    Nevada: 'NV',
    'New Hampshire': 'NH',
    'New Jersey': 'NJ',
    'New Mexico': 'NM',
    'New York': 'NY',
    'North Carolina': 'NC',
    'North Dakota': 'ND',
    Ohio: 'OH',
    Oklahoma: 'OK',
    Oregon: 'OR',
    Pennsylvania: 'PA',
    'Puerto Rico': 'PR',
    'Rhode Island': 'RI',
    'South Carolina': 'SC',
    'South Dakota': 'SD',
    Tennessee: 'TN',
    Texas: 'TX',
    Utah: 'UT',
    Vermont: 'VT',
    'Virgin Islands': 'VI',
    Virginia: 'VA',
    Washington: 'WA',
    'West Virginia': 'WV',
    Wisconsin: 'WI',
    Wyoming: 'WY',
};

const makeBool = val => {
    // will turn 'true' or true into true, 'false' or false into false
    // everything else returns undefined
    if (val === 'true' || val === true) {
        return true;
    } else if (val === 'false' || val === false) {
        return false;
    } else {
        return undefined;
    }
};

export {
    capitalize,
    snakeCaseToCapitalCase,
    toSnakeCase,
    toKebabCase,
    cropAndEllipsis,
    addMonths,
    addDays,
    writtenNumber,
    phoneFormat,
    printValue,
    dateFormatter,
    numberDaysBetween,
    stateAbbreviationDict,
    makeBool,
};
